var map = {
	"./0.jpg": "2eoi",
	"./1.jpg": "mS2x",
	"./2.jpg": "NkmL",
	"./3.jpg": "AylJ",
	"./4.jpg": "/xeH",
	"./5.jpg": "p74n",
	"./6.jpg": "+4hJ",
	"./7.jpg": "AxOw",
	"./8.jpg": "A+oZ"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "k2G/";